<ion-header *ngIf="isMobile">
  <ion-toolbar>
    <!-- <ion-title>{{ title }}</ion-title> -->
    <ion-buttons slot="end">
      <ion-button (click)="close()" fill="clear" class="close-button">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<!-- <div class="custom-header">
  <ion-button fill="clear" class="close-button" (click)="close()">
    <ion-icon name="close" slot="icon-only"></ion-icon>
  </ion-button>
</div> -->
<ion-content class="ion-no-padding offer-modal-content">
  <div class="bgHighlight">
    <div class="custom-header" *ngIf="isWebView">
      <ion-button fill="clear" class="close-button" (click)="close()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
    <div class="offer-icon-container">
      <ion-img [src]="icon" [alt]="title"></ion-img>
    </div>

    <h2 class="offer-title">{{ title }}</h2>
    <p class="offer-amount">Eligible Amount <span>{{ amount }}</span></p>
  </div>
  <p class="offer-description">
    {{description}}
  </p>

  <!-- <ion-button expand="block" color="primary" (click)="close()">
    Get More Details
  </ion-button> -->

  <app-primary-button [label]="'Interested'" [loading]="false" customClass="primaryBtn" (clicked)="initiateESign()">
  </app-primary-button>
  <ion-note class="fadedNote">Terms and conditions apply.</ion-note>
</ion-content>

<!-- <ion-footer class="offer-modal-footer" *ngIf="isWebView">
  <ion-toolbar>
    <app-primary-button [label]="'Interested'" [loading]="false" customClass="primaryBtn" (clicked)="initiateESign()">
    </app-primary-button>
    <ion-note class="fadedNote">Terms and conditions apply.</ion-note>
  </ion-toolbar>
</ion-footer> -->